import React, { useState, useEffect } from "react"
import {Button, Input, Page, Card, Row} from 'react-onsenui';
import styles from './index.module.css'
import inlineStyles from "./inlineStyles";
import { useDeviceName, useEditingDeviceName } from "./useDeviceName";
import { IconPencil } from '@tabler/icons-react'

const DeviceName = () => {

    const [deviceName, setDeviceName] = useDeviceName()
    const {editingDeviceName, setEditingDeviceName} = useEditingDeviceName()
    const [pendingDeviceName, setPendingDeviceName] = useState()

    useEffect(() => {
        // localStorage.removeItem('StarStreamScannerDeviceName')
        const scannerDeviceName = localStorage.getItem("StarStreamScannerDeviceName")
        if (scannerDeviceName) {
            setEditingDeviceName(false)
            setPendingDeviceName(scannerDeviceName)
            setDeviceName(scannerDeviceName)
        } else {
            setEditingDeviceName(true)
            setPendingDeviceName(scannerDeviceName)
            setDeviceName(scannerDeviceName)
        }
    }, [])

    const save = () => {
        if (pendingDeviceName && pendingDeviceName.length > 0) {
            localStorage.setItem('StarStreamScannerDeviceName', pendingDeviceName)
            setDeviceName(pendingDeviceName)
            setEditingDeviceName(false)
        } else {
            setPendingDeviceName('')
        }
    }

    const cancel = () => {
        setPendingDeviceName(deviceName)
        setEditingDeviceName(false)
    }

    return (
        <>
            <div>
                <button
                    className={styles.editButton}
                    onClick={() => setEditingDeviceName(true)}
                >
                    <h2 className={styles.deviceNameText}>{deviceName}</h2>
                    <div className={styles.editIconWrapper}>
                        <IconPencil size={14} className={styles.editIcon}/>
                    </div>
                </button>
            </div>

            {editingDeviceName &&

                <Page contentStyle={inlineStyles.modalBody}>

                    <h1>Device name</h1>

                    <Card class={styles.fieldBox}>
                        {pendingDeviceName === '' &&
                            <div className={styles.error}>Device name can't be blank</div>
                        }
                        <Input
                            placeholder='Please give a name to this scanner'
                            class={styles.field}
                            value={pendingDeviceName}
                            onInput={event => setPendingDeviceName(event.target.value)}
                        />
                    </Card>

                    <Row style={inlineStyles.buttonWrapper}>
                        <Button
                            class={styles.saveButton}
                            modifier="large"
                            disabled={pendingDeviceName === ''}
                            onClick={save}
                        >
                            Save
                        </Button>
                    </Row>

                    {deviceName &&
                        <Row style={inlineStyles.buttonWrapper}>
                            <Button
                                class={styles.cancelButton}
                                modifier="large outline"
                                disabled={deviceName === ''}
                                onClick={cancel}
                            >
                                Cancel
                            </Button>
                        </Row>
                    }

                    <div className={styles.notice}>
                        <p>Bookmark this webpage to access the Scanner quickly</p>
                        <p>Share this URL with your employee, so they can scan tickets too</p>
                    </div>
                </Page>
            }
        </>
    )
}

export default DeviceName
